import httpClient from '@xver/libs/axios';

import { ProductsPricingResponse } from './model';

const ENDPOINTS = {
    GET_PRODUCTS: '/v1/pricing/products',
};

export function getProductsPricing(): Promise<ProductsPricingResponse> {
    return httpClient.get(ENDPOINTS.GET_PRODUCTS);
}
